// extracted by mini-css-extract-plugin
export var card = "_6c-1";
export var container = "_6c-0";